import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { BrandColors } from '../../constants/brandColors';

export const RatingAnswerButtonStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: (props: { variant: string }) => ({
      width: '-webkit-fill-available',
      height: '3rem',
      borderRadius: 8,
      fontWeight: 'bolder',
      padding: '0px',
      minWidth: '3rem',
      '@media screen and (device-aspect-ratio: 40/71) and (device-width : 320px)': {
        minWidth: '2.7rem',
        height: '2.7rem',
      },
      boxShadow: '0 8px 20px rgb(0 0 0 / 8%)',
      background: theme.palette.background.paper,
      border: `2px solid ${theme.palette.borderColor?.main || BrandColors.transparent}`,
      color: theme.palette.default?.main,
      [theme.breakpoints.up('md')]: {
        height: props.variant === 'QU' ? '6rem' : '3rem',
        width: '100%',
        minWidth: '3rem',
      },
      '&:hover': {
        color: theme.palette.secondary.contrastText,
        background: theme.palette.primary.contrastText,
      },
      '&:focus-visible': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.background.default,
      },
    }),
    errorText: {
      color: BrandColors.red39,
    },
    selected: {
      color: `${theme.palette.secondary.contrastText} !important`,
      background: `${theme.palette.primary.contrastText} !important`,
    },
    error: {
      border: '1px solid !important',
      borderColor: `${BrandColors.red39} !important`,
    },
    label: (props: { variant: string }) => ({
      height: '1.74em',
      fontSize: '1.5rem',
      fontWeight: 'bold',
      [theme.breakpoints.up('md')]: {
        fontSize: props.variant === 'QU' ? '3rem' : '1.5rem',
        lineHeight: '100%',
      },
    }),
    labelIcon: (props: { variant: string }) => ({
      fontSize: '1.5rem',
      fontWeight: 'bold',
      [theme.breakpoints.up('md')]: {
        fontSize: props.variant === 'QU' ? '3rem' : '2rem',
      },
    }),
    text: {
      fontWeight: 600,
      color: theme.palette.default?.main,
      marginTop: '1.2rem',
      display: 'block',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.7rem',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '1.12rem',
        lineHeight: '128%',
      },
    },
    textAlignLeft: {
      textAlign: 'left',
      minWidth: '3.12rem',
    },
    textAlignRight: {
      textAlign: 'right',
      [theme.breakpoints.up('sm')]: {
        marginRight: '-1rem',
      },
      [theme.breakpoints.up('md')]: {
        marginRight: '0',
      },
    },
    answerBlock: (props: { variant: string }) => ({
      display: 'grid',
      gridAutoFlow: 'column',
      gridGap: '0.75rem',
      paddingTop: props.variant === 'QU' ? '2rem' : 'initial',
      paddingInline: '1rem',
      overflow: 'hidden',
      '@media screen and (-ms-high-contrast:active), (-ms-high-contrast:none)': {
        display: '-ms-flexbox',
      },
      [theme.breakpoints.up('sm')]: {
        gridGap: props.variant === 'QU' ? '1.875rem' : '1rem',
        paddingTop: props.variant === 'QU' ? '2.75rem' : 'initial',
        justifyContent: 'center',
        '@media screen and (-ms-high-contrast:active), (-ms-high-contrast:none)': {
          justifyContent: 'flex-end',
        },
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '375px',
        margin: '0 auto',
        padding: props.variant === 'QU' ? '1rem' : '1rem 0rem 0rem 0rem',
      },
    }),
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      maxWidth: '100px',
      justifyContent: 'flex-end',
      '@media screen and (-ms-high-contrast: none)': {
        marginRight: '1rem',
        maxWidth: 'none',
      },
    },
    VAButtons: {
      '@media screen and (-ms-high-contrast: none)': {
        marginRight: '1rem',
      },
    },
    displayNone: {
      display: 'none !important',
    },
    divider: (props: { variant: string }) => ({
      width: '0.125rem',
      height: '3.438rem',
      marginRight: props.variant === 'VA' ? '0.5rem' : '0.625rem',
      marginLeft: '0rem',
      marginTop: 0,
      background: theme.palette.default?.main,
      opacity: 0.3,
      '@media screen and (min-device-width: 600px) and (max-device-width: 950px)': {
        marginRight: props.variant === 'QU' ? '0.2rem' : '0.625rem !important',
      },
      '@media screen and (device-aspect-ratio: 40/71) and (device-width : 320px)': {
        marginRight: props.variant === 'QU' ? '0.313rem' : '0.625rem !important',
      },
      '@media screen and (min-device-width: 376px) and (max-device-width: 414px)': {
        marginRight: props.variant === 'VA' ? '1rem' : '0.625rem',
      },
      [theme.breakpoints.up('md')]: {
        clear: 'both',
        marginLeft: props.variant === 'QU' ? '-0.625rem' : '-0.3rem',
        marginRight: props.variant === 'QU' ? '1rem' : '0.7rem',
        marginTop: 0,
        height: props.variant === 'QU' ? '100%' : '80%',
      },
      '@media screen and (-ms-high-contrast: none)': {
        marginRight: props.variant === 'QU' ? '0.625rem !important' : '0.7rem',
        marginLeft: props.variant === 'QU' ? '-0.3125rem !important' : '-0.3rem',
      },
    }),
    gridColumns5: {
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
      msGridColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
    },
    gridColumns6: {
      gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
      msGridColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns:
          'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr)',
        msGridColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr)',
      },
    },
    '@media screen and (min-color-index:0) and (-webkit-min-device-pixel-ratio:0)': {
      '@media': {
        gridColumns5: {
          [theme.breakpoints.up('md')]: {
            gridTemplateColumns: 'auto !important',
          },
        },
        gridColumns6: {
          [theme.breakpoints.up('md')]: {
            gridTemplateColumns: 'auto !important',
          },
        },
      },
    },
    IEOnlyAnswers: {
      maxWidth: '100px',
      '@media screen and (-ms-high-contrast: none)': {
        marginRight: '1rem',
        flexGrow: 1,
        flexBasis: '50px',
        maxWidth: 'none',
      },
    },
    submitButtonLoader: {
      color: theme.palette.primary.contrastText,
      position: 'absolute',
    },
  }),
);
